export enum FormStatus {
    INITIAL,
    SUBMITTING,
    SUBMITTED,
    ERROR,
}

export interface FormData {
    email: string;
    ctaId: number;
}
